import { useThemeColors } from '@/shared/theme/useThemeColors';
import { typography, semantic, radius } from '@/shared/theme/tokens';
import { AlertTickerItem } from './AlertTickerItem';

/**
 * Left-region alert rail. Alerts arrive pre-ranked from the screen
 * (severity → actionability → recency, stale sunk); colour tracks each value's
 * *current* standing. Scrolls internally so the panel never blows out the
 * screen height.
 */
export function AlertRail({ alerts = [], flashId, animate, onSelect }) {
  const c = useThemeColors();
  const sorted = alerts;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1,
      borderRadius: radius['2xl'], border: `1px solid ${c.border}`, background: c.bg, overflow: 'hidden',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px',
        borderBottom: `1px solid ${c.border}`, flexShrink: 0,
      }}>
        <span className="material-symbols-outlined" style={{ fontSize: 18, color: semantic.error }}>
          notifications_active
        </span>
        <span style={{ fontFamily: typography.fontFamily.heading, fontSize: typography.fontSize.lg, fontWeight: typography.fontWeight.bold, color: c.textPrimary }}>
          Live Alerts
        </span>
        <span style={{ marginLeft: 'auto', fontSize: typography.fontSize.sm, color: c.textSubtle, fontVariantNumeric: 'tabular-nums' }}>
          {sorted.length}
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: 12, overflowY: 'auto', minHeight: 0 }}>
        {sorted.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '28px 12px', color: c.textSubtle }}>
            <span className="material-symbols-outlined" style={{ fontSize: 30, color: semantic.successAlt }}>check_circle</span>
            <span style={{ fontSize: typography.fontSize.md }}>All parameters in range</span>
          </div>
        ) : (
          sorted.map((a) => (
            <AlertTickerItem key={a.id} alert={a} flashing={a.id === flashId} animate={animate} onSelect={onSelect} />
          ))
        )}
      </div>
    </div>
  );
}
